import React from 'react';
import { Link } from 'react-router-dom';

export const Left = (props: any) => {
  const handleOpenCloseLeft = props.handleOpenCloseLeft
  const isOpen = props.isOpen

  return (
    <React.Fragment>
      {/* Left Navigation  */}
      <div className={`metaportal_fn_leftnav_closer ${isOpen ? "active" : ""}`} onClick={handleOpenCloseLeft}  ></div>
      <div className={`metaportal_fn_leftnav ${isOpen ? "active" : ""}`}>
        <a href="#" className="fn__closer" onClick={handleOpenCloseLeft} ><span></span></a>
        <div className="navbox" style={{justifyContent:"flex-start"}}>
          <div className="list_holder">
          <div className="logo">
            <img src="/img/logo.png" alt="" width="250" height="75" />
          </div>
            <ul className="metaportal_fn_items">
              <li>
                <div className="item">
                  {/* PROD */}
                  <a href="https://diva.multimedianusantara.id/api/diva/admin/admin-logout"></a>
                  {/* LOCAL */}
                  {/* <a href="http://localhost/diva-backend/web/admin/admin-logout"></a> */}
                  <span className="text">Logout</span>
                </div>
              </li>
            </ul>
          </div>
          <div className="nav_holder">

            {/* For JS  */}
            <span className="icon">
              <img src="svg/down.svg" alt="" className="fn__svg" />
            </span>
            {/* !For JS  */}

            <ul>
              <Link to="/admin/document-monitoring"><span className="creative_link">Document Monitoring</span></Link>
              <br />
            </ul>
          </div>
          <div className="info_holder">
            <div className="copyright">
              {/* <p>Copyright 2022 - Designed &amp; Developed by <a href="https://themeforest.net/user/frenify/portfolio" target="_blank">Frenify</a></p> */}
            </div>
            <div className="social_icons">
              <ul>
                <li><a href="#"><img src="svg/social/twitter-1.svg" alt="" className="fn__svg" /></a></li>
                <li><a href="#"><img src="svg/social/facebook-1.svg" alt="" className="fn__svg" /></a></li>
                <li><a href="#"><img src="svg/social/instagram-1.svg" alt="" className="fn__svg" /></a></li>
                <li><a href="#"><img src="svg/social/pinterest-1.svg" alt="" className="fn__svg" /></a></li>
                <li><a href="#"><img src="svg/social/behance-1.svg" alt="" className="fn__svg" /></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* !Left Navigation  */}
    </React.Fragment>
  )


}





